import { useState, useEffect } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Typography } from '@mui/material';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import Cheque from '../../../../../Models/Cheque';
import EsCompte from '../../../../../Models/EstCompte';
import VerifDay from '../../../../../Functions/Traitement/VerifDay';
import { useNavigate } from 'react-router-dom';

//import '../../../../Assets/Styles/StyleForm.css';
const Swal = require('sweetalert2');

const EstCompte = () => {
    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader()

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [StartSearchG, SeStartSearchG] = useState(false);
    const [StartForm, SetStartForm] = useState(true);
    const [, forceUpdate] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [modifActve, setModifActve] = useState(true)
    const [enregActve, setEnregActve] = useState(true)
    const [consulActive, setConsulActive] = useState(false)
    const [sbmit, setSbmit] = useState("");
    const [DataCheque, setDataCheque] = useState<Cheque[]>([]);
    // const [DataOperationV, setDataOperationV] = useState<DataHistoCpt[]>([]);
    const [StartRef, SetStartRef] = useState(false);
    const Navigate=useNavigate();

    useEffect(() => {
        forceUpdate({});
        if (StartForm == true) {
            consult();
            VerifDay(user.coduti,user.codage,authHeader,Navigate);
            let DateD = user.datjour;
            form.setFieldValue("DATOPE", DateD);
            SetStartForm(false);
        }
    }, []);


    function initialiazeButton() {
        setAjoutActif(false)
        setModifActve(true)
        setEnregActve(true)
        setConsulActive(false)
    }

    function cunsultButton() {
        //setAnnulActive(false)
        setModifActve(false);
        SetStartRef(true);
        SetStart();
        // SetActivetabs(true)
    }

    const SetStart = async () => {
        setLoading(true);

        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetGetCodeOperat,
            headers: {
                'CypherChampOpe': Crypter.encrypt('OPE074'),
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
            },
        };

        await axios.request(config)
            .then((response) => {
                setLoading(false);
                if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                    if (res.StatutCode == 200) {
                        let datas = res.Result[0];
                        let DateD = user.datjour;
                        form.setFieldsValue({
                            "CODOPES": datas.OPE074,
                            "lib_CODOPES": datas.LIBELL,
                            "DATOPE": DateD
                        })

                        setSbmit("add");
                        setAjoutActif(true);
                        setEnregActve(false);
                        setConsulActive(true);
                    }
                    else {
                        SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                    }
                }
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
            });
        setLoading(false)
    }


    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Escompte  chèques remis encaissement
                </span>
            ),
            children: <Tab1 etatG={StartRef} form={form} DataCheque={DataCheque} OnModif={cunsultButton} />,
        }
    ]

    const onFinish = (values: any) => {

        let Escompte: EsCompte = values;
        Escompte.DATOPE = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
        Escompte.UTISAI = user.coduti;
        Escompte.AGCCPT = user.codage;
        Escompte.CODOPE = values.CODOPES;
        Escompte.LIBELL = values.lib_CODOPES;
        Escompte.CODBANK = values.BANCLT;
        Escompte.IDESCOMPTE = values.Id;

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "EsCompte chèque ",
                text: "Voulez-vous  effectuer l'EsCompte chèque du montant: " + formatNumber(form.getFieldValue('MONTANT')) + ' XAF ' + " pour " + form.getFieldValue('lib_CODOPES') + " ? ",
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: 'question'
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true);
                    //let group = profilsDistant.find(()=>)
                    let data = Crypter.encrypt(JSON.stringify(Escompte));

                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.EscompteCheque,
                        headers: {
                            'Authorization': authHeader(),
                            'Accept': '*/*',
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                if (res.StatutCode == 200) {

                                    form.resetFields();
                                    form.setFieldsValue({ 'NUMCLI': values.NUMCLI, 'lib_NUMCLI': values.lib_NUMCLI });

                                    setIsSubmit(false);
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
                                    consult();
                                    setSbmit("");

                                }
                                else {
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "error" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                        });
                }
            })
        }

    };


    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const consult = async () => {

        setLoading(true);
        setDataCheque([]);

        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetChequeAccount,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherNumcli': Crypter.encrypt(''),
                'CypherAgence': Crypter.encrypt(user.codage),
                'CypherOption': Crypter.encrypt('4'),

            }
        };

        await
            axios(config)
                .then((response) => {
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            let datas = res.Result;

                            const Datat: Cheque[] = [];
                            if (datas.length === 0) {
                                SweetAlert.fire({ title: "Warning", text: "aucun élément", icon: "warning" })
                            }
                            else {
                             
                                res.Result.map((data: any, indice: number) => {
                                    Datat.push({
                                        key: indice,
                                        Id: data.Id,
                                        CODOPE: data.CODOPE,
                                        NUMCPT: data.NUMCPT,
                                        NUMCHQ: data.NUMCHQ,
                                        CPTCHQRECOUVRE: data.CPTCHQRECOUVRE,
                                        BANCLT: data.BANCLT,
                                        DATOPE: data.DATOPE,
                                        MONTRES:formatNumber(data.MONTRES),
                                        MONTAN: formatNumber(data.MONTAN),
                                        LIBECR: data.LIBECR,
                                        REMETT: data.REMETT,
                                        CPTBAN: data.CPTBAN,
                                        NUMBAN: data.NUMBAN,
                                        CPTCLT: data.CPTCLT,
                                        DATSAI: data.DATSAI,
                                        BORDER: data.BORDER,
                                        DATVAL: data.DATVAL,
                                        CPTJNX: data.CPTJNX,
                                        CDETAT: data.CDETAT,
                                        CPTCHC: data.CPTCHC,
                                        AGCCPT: data.AGCCPT,
                                        NBRIMPAIE: data.NBRIMPAIE,
                                        CPTRECOUVRE: data.CPTRECOUVRE,
                                        MTESCOMPTE: data.MTESCOMPTE,
                                        CPTENCCOR: data.CPTENCCOR,
                                        VALNONPAIPRE: data.VALNONPAIPRE,
                                        cptescompte: data.cptescompte,
                                        Lib_BANQUE: data.BANCLT + "-" + data.lib_BANCLT,
                                        RelObject: data
                                    });
                                    setDataCheque(Datat);
                                })
                            }
                        } else SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                        setLoading(false);
                    }
                    //  setLoad(false);
                }).catch((error) => {
                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })

        setLoading(false);
    }

    function modifButton() {
        setModifActve(true)
        setAjoutActif(true)
        SetStartRef(true);
        setEnregActve(false)
        setConsulActive(true)
        setSbmit("update");
    }

    function modif() {
        modifButton()
    }

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> Estcompte Chèque </b></Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {/* <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                                    Consulter 
                                </Button> */}
                                {/* <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button> */}
                                {/* <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button> */}
                                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' type="ghost" disabled={false} htmlType="button" block>
                                    Actualiser
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" onChange={(e) => { if (e == '2') { } }} defaultActiveKey="1" items={items} />
                        </div>
                        <div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}
export default EstCompte;